<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <agentVendorShop @select="selectHandler" />

      <el-form-item label="机器ID">
        <el-input
          v-model="formInline.machineid"
          placeholder="请输入机器ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="机器类型">
        <el-select
          v-model="formInline.machineType"
          placeholder="请选择"
          @change="handleChangeMachineType"
        >
          <el-option label="全部" :value="''"></el-option>
          <el-option
            v-for="(item, index) in $AllMachineModelInfoList"
            :key="index"
            :label="item.machineTypeCnName"
            :value="item.machineTypeCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机器型号">
        <el-select v-model="formInline.machineModel" placeholder="请选择">
          <el-option label="全部" :value="''"></el-option>
          <template v-if="formInline.machineType">
            <el-option
              v-for="(item, index) in $AllMachineModelInfoList.find(
                ele => ele.machineTypeCode === formInline.machineType
              ).machineSpec"
              :key="index"
              :label="item.machineModel + '【' + item.machineModelName + '】'"
              :value="item.machineModel"
            ></el-option>
          </template>
        </el-select>
      </el-form-item>

      <el-form-item label="起止时间">
        <el-date-picker
          v-model="formInline.date"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item style="margin-left:1.5rem;">
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="machineid" label="机器id" width="150">
        <template slot-scope="scope">
          <router-link
            class="link-div"
            tag="div"
            :to="{ name: 'machine', query: { machineid: scope.row.machineid } }"
            >{{ scope.row.machineid }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column label="类型" width="80">
        <template slot-scope="scope">
          {{ scope.row.machineExtendModel.machineTypeCnName }}
        </template>
      </el-table-column>
      <el-table-column prop="machineModel" label="型号" width="180">
        <template slot-scope="scope">
          {{ scope.row.machineExtendModel.machineModel }}
        </template>
      </el-table-column>
      <el-table-column prop="machineName" label="名称" width="200">
        <template slot-scope="scope">
          {{ scope.row.machineExtendModel.machineName }}
        </template>
      </el-table-column>
      <el-table-column label="加盟商" width="200">
        <template slot-scope="scope">
          {{ scope.row.vendorEntity.vendorName }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="machineCity" label="城市"></el-table-column> -->
      <el-table-column label="所属门店" width="200">
        <template slot-scope="scope">
          {{ scope.row.shopInfoEntity.shopName }}
        </template>
      </el-table-column>
      <el-table-column label="频率（机器单数/门店单数）" width="200">
        <template slot-scope="scope">
          {{ scope.row.orderCountInMachine }} /
          {{ scope.row.orderCountInShop }}
        </template>
      </el-table-column>
      <el-table-column label="频率" width="200">
        <template slot-scope="scope">
          <el-progress
            :text-inside="true"
            :stroke-width="16"
            :percentage="
              Math.trunc(
                scope.row.orderCountInShop == 0
                  ? 0
                  : (100 * scope.row.orderCountInMachine) /
                      scope.row.orderCountInShop
              )
            "
            :color="customColors"
          ></el-progress>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
  </div>
</template>

<script>
import enumObject from "../../../plugins/enum";
import agentVendorShop from "@/components/layout/agentVendorShop";

//import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    agentVendorShop
  },
  data() {
    return {
      formInline: {
        machineid: "",
        machineType: "",
        machineModel: "",
        agentid: "",
        vendorid: "",
        machineInShopid: "",
        agentName: "",
        vendorName: "",
        shopName: "",
        date: [moment().subtract(1, "month"), moment()]
      },
      tableData: [],
      customColors: [
        { color: "#909399", percentage: 5 },
        { color: "#409EFF", percentage: 30 },
        { color: "#E6A23C", percentage: 60 },
        { color: "#67C23A", percentage: 60 }
      ],
      CITY_ENUM: enumObject.CITY_ENUM,
      MACHINE_STATUS_ENUM: enumObject.MACHINE_STATUS_ENUM,
      //vendorsList: [],
      machineEnableList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "是",
          value: true
        },
        {
          label: "否",
          value: false
        }
      ],
      multipleSelection: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      isCreated: false,
      isEdit: false,
      isPrint: false,
      isControl: false,
      machineInfo: null,
      imageIDs: [],
      // shopInfoEntityList: [],
      // vendorEntityList: [],
      machineModelList: [],
      //vendorList: [],
      //shopList: [],
      //agentList: []
      agentListForPrompt: [],
      vendorListForPrompt: [],
      shopListForPrompt: []
    };
  },

  async mounted() {
    if (this.$route.query.shopid) {
      //await this.getShops({ shopid: this.$route.query.shopid });
      this.formInline.machineInShopid = this.$route.query.shopid;
    }

    if (this.$route.query.machineid) {
      this.formInline.machineid = this.$route.query.machineid;
    }

    if (this.$route.query.machineStatus != undefined) {
      this.formInline.machineStatus = this.$route.query.machineStatus;
    }
  },

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      this.formInline.machineInShopid = x.selectedShop.shopid;
    },
    onSubmit() {
      let queryModel = {
        machineid: this.formInline.machineid,
        machineType: this.formInline.machineType,
        machineModel: this.formInline.machineModel,
        vendorid: this.formInline.vendorid,
        agentid: this.formInline.agentid,
        machineInShopid: this.formInline.machineInShopid,
        dateFrom: Array.isArray(this.formInline.date)
          ? this.$ToDateString(this.formInline.date[0])
          : null,
        dateTo: Array.isArray(this.formInline.date)
          ? this.$ToDateString(this.formInline.date[1])
          : null,

        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      if (this.formInline.machineModel == "全部") {
        queryModel.machineModel = null;
      }
      this.$axios(this.$urlMapping["查询机器使用次数"], {
        data: queryModel
      }).then(result => {
        // this.tableData = result.data.map(ele => ele.machineExtendModel);
        // this.shopInfoEntityList = result.data
        //   .map(ele => ele.shopInfoEntity)
        //   .filter(ele => ele !== null);
        // this.vendorEntityList = result.data
        //   .map(ele => ele.vendorEntity)
        //   .filter(ele => ele !== null);
        this.tableData = result.data;

        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    // getPercent(val) {

    //     return Math.trunc(val * 100);

    // },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    handleChangeMachineType() {
      this.formInline.machineModel = "";
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 252px;
}
</style>
